import React, {Component} from 'react';
import { connect } from 'react-redux';
import * as billingActions from '../actions/index';

import LoadingIndicator from '../../global/loading_indicator/loading_indicator';
import DetailHeader from '../../global/detail_header/detail_header';
import Button from '../../global/button/button';

class BillingDetails extends Component {

    componentDidMount() {
        this.props.onFetchBillingDetails();
        this.props.onFetchSubscriptionSummary();
    }

    formatPrice(amount, currency) {
        const dollars = (amount / 100).toFixed(2).replace(/\.00$/, '');
        const symbol = currency === 'usd' ? '$' : currency.toUpperCase() + ' ';
        return `${symbol}${dollars}`;
    }

    formatDate(timestamp) {
        const date = new Date(timestamp * 1000);
        return date.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
    }

    render () {
        if (this.props.loading_payment_details || this.props.loading_subscription_summary) {
            return <LoadingIndicator />;
        }

        let subtitle = (
            <span>Manage your payment method, invoices, and subscription details through the billing portal.</span>
        );

        let subscriptionSection = null;

        if (this.props.subscription_summary && this.props.subscription_summary.length > 0) {
            subscriptionSection = (
                <div className="my-6">
                    {this.props.subscription_summary.map(sub => (
                        <div key={sub.id} className="rounded-lg border border-gray-200 p-5 mb-4">
                            <div className="flex items-center justify-between mb-3">
                                <span className={
                                    "text-sm font-medium px-2 py-1 rounded-sm " +
                                    (sub.status === 'trialing'
                                        ? "bg-yellow-100 text-yellow-800"
                                        : "bg-green-100 text-green-800")
                                }>
                                    {sub.status === 'trialing' ? 'Trial' : 'Active'}
                                </span>
                                {sub.cancel_at_period_end && (
                                    <span className="text-sm text-red-500">Cancels at end of period</span>
                                )}
                            </div>

                            {sub.items.map((item, idx) => (
                                <div key={idx} className="flex items-center justify-between py-2">
                                    <span className="text-base font-medium text-gray-800">
                                        {item.product_name}
                                        {item.quantity > 1 && (
                                            <span className="text-sm text-gray-500 ml-2">x{item.quantity}</span>
                                        )}
                                    </span>
                                    <span className="text-base text-gray-600">
                                        {this.formatPrice(item.amount * (item.quantity || 1), item.currency)}/{item.interval}
                                    </span>
                                </div>
                            ))}

                            <div className="mt-3 pt-3 border-t border-gray-100 text-sm text-gray-500">
                                {sub.status === 'trialing' && sub.trial_end && (
                                    <span>Trial ends {this.formatDate(sub.trial_end)}</span>
                                )}
                                {sub.status === 'active' && sub.current_period_end && (
                                    <span>Renews {this.formatDate(sub.current_period_end)}</span>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            );
        }

        return (
            <div>
                <DetailHeader title="Billing" subtitle={subtitle} />

                {subscriptionSection}

                <div className="my-8">
                    <a
                        onClick={() => this.props.onOpenCustomerPortal()}
                        className="flex items-center justify-center gap-2 w-full rounded-lg bg-blue-500 px-4 py-3 text-base font-semibold text-white cursor-pointer hover:bg-blue-600 hover:text-white shadow-xs"
                    >
                        Manage Billing on Stripe
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                        </svg>
                    </a>
                </div>

                <p className="text-xs text-gray-500 font-sans py-1 cursor-default">Charges will appear as "WorshipKit LLC" on your statements. For questions about specific charges or billing, please <a className="text-blue-500 underline hover:bg-white hover:text-blue-500 hover:underline cursor-pointer" href="mailto:support@worshipkit.com">get in touch</a>.</p>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        loading_payment_details: state.billing.loading_payment_details,
        loading_subscription_summary: state.billing.loading_subscription_summary,
        subscription_summary: state.billing.subscription_summary,
    };
}

const mapDispatchToProps = dispatch => {
    return {
        onFetchBillingDetails: () => dispatch(billingActions.fetchBillingDetails()),
        onFetchSubscriptionSummary: () => dispatch(billingActions.fetchSubscriptionSummary()),
        onOpenCustomerPortal: () => dispatch(billingActions.openCustomerPortal()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(BillingDetails);
